import { combineReducers } from 'redux';

import consultarNaturalidades from './consultarNaturalidades/reducer';
import atualizarNaturalidade from './atualizarNaturalidade/reducer';
import cadastrarNaturalidade from './cadastrarNaturalidade/reducer';
import excluirNaturalidade from './excluirNaturalidade/reducer';

export default combineReducers({
	consultarNaturalidades,
	atualizarNaturalidade,
	cadastrarNaturalidade,
	excluirNaturalidade,
});
